import { ElasticCobaltSortKeyEnumType } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import {
    ElasticSortKeyOption,
    ElasticSortTypeOption,
    SortContextType,
    useSearchSort,
} from '../search-windows/use-search-sort';

const sortByOptions: ElasticSortKeyOption[] = [
    {
        label: 'Event Date',
        value: 'COBALT_CAD_TICKET_START_DATE_UTC',
    },
    { label: 'Priority', value: 'COBALT_CAD_TICKET_PRIORITY' },
];

const directionOptionsBySortKey: Partial<
    Record<ElasticCobaltSortKeyEnumType, ElasticSortTypeOption[]>
> = {
    COBALT_CAD_TICKET_START_DATE_UTC: [
        {
            label: 'Newest First',
            value: 'DATE_MOST_RECENT_TO_LEAST_RECENT',
        },
        {
            label: 'Oldest First',
            value: 'DATE_LEAST_RECENT_TO_MOST_RECENT',
        },
    ],
    COBALT_CAD_TICKET_PRIORITY: [
        {
            label: 'Highest First',
            value: 'PRIORITY_HIGHEST_TO_LOWEST',
        },
        {
            label: 'Lowest First',
            value: 'PRIORITY_LOWEST_TO_HIGHEST',
        },
    ],
};

const SortContext = createContext<SortContextType | undefined>(undefined);

export function useEventSearchSortContext() {
    const context = useContext(SortContext);
    if (context === undefined) {
        throw new Error('useEventSearchSortContext must be used within an EventSearchSortProvider');
    }
    return context;
}

export const EventSearchSortProvider = ({ children }: { children: ReactNode }) => {
    const sort = useSearchSort(sortByOptions, directionOptionsBySortKey);
    return <SortContext.Provider value={sort}>{children}</SortContext.Provider>;
};
